import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-dark py-12 px-4" data-id="element-97">
      <div className="max-w-4xl mx-auto text-center" data-id="element-98">
        <h3 className="text-2xl font-display font-bold text-gold-accent mb-3" data-id="element-99">
          ฟุตบอล พร้อม
        </h3>
        <p className="text-gray-300 mb-4 leading-relaxed" data-id="element-100">
          วิธีที่ดีที่สุดในการสอนฟุตบอลโดยไม่ต้องเตรียมการเอง
          <br data-id="element-101" />
          เครื่องมือที่ใช้งานได้จริงสำหรับอาจารย์ที่ต้องการผลลัพธ์ที่จับต้องได้
        </p>
        <div className="border-t border-gray-700 pt-6 mt-6" data-id="element-102">
          <p className="text-gray-400 text-sm mb-2" data-id="element-103">
            © 2026 — สงวนลิขสิทธิ์ทั้งหมด
          </p>
          <p className="text-gray-500 text-sm" data-id="element-104">
            สินค้าดิจิทัล — PDF ดาวน์โหลดได้ทันที
          </p>
        </div>
      </div>
    </footer>;
}